import * as _ from 'lodash';

import * as ALARM_CATEGORIES from './alarmCategories.constants';
import * as ALARMS from '../alarms/alarms.constants';
import ReducerCreator from '../registerReducer';
import { StoreItem, DispatchEvent } from '../Store';
import { APPLICATION_DISCONNECTED } from '../application/application.constants';
import { AlarmList } from '../../models';

const r = new ReducerCreator<string>()
    // Clean dictionary if application is disconnected
    .register<string>(APPLICATION_DISCONNECTED, (state, payload) => {
        return new StoreItem<string>();
    })
    // Start loading all alarm categories
    .register<string[]>(ALARM_CATEGORIES.ALARM_CATEGORIES_LOAD, (state, payload) => {
        return {
            dictionary: {},
            isLoading: true,
            isLoaded: false,
            hasError: false,
            error: null
        };
    })
    // Set loaded alarm categories to store
    .register<string[]>(ALARM_CATEGORIES.ALARM_CATEGORIES_LOAD_SUCCESS, (state, payload) => {
        return buildAlarmCategoriesStoreItem(payload);
    })
    // On load alarm categories error
    .register<any>(ALARM_CATEGORIES.ALARM_CATEGORIES_LOAD_ERROR, (state, reason) => {
        return {
            dictionary: {},
            isLoading: false,
            isLoaded: false,
            hasError: true,
            error: reason.data.Message || reason.message
        };
    })
    //If alarm if added, updated or deleted, update alarm categories in store
    .register<AlarmList>(ALARMS.ALARMS_AFTER_UPDATE, (state, payload) => {
        const newState = buildAlarmCategoriesFromAlarmListStoreItem(payload);
        return newState;
    });

export function alarmCategoriesReducer(state: StoreItem<string> = new StoreItem<string>(), action: DispatchEvent<any>) {
    return r.reduce(state, action);
}

// Build store item of alarm categories with alarm categories
function buildAlarmCategoriesStoreItem(payload: string[]): StoreItem<string> {
    const dic = {};
    payload.forEach(p => dic[p] = p);
    return {
        dictionary: dic,
        isLoading: false,
        isLoaded: true,
        hasError: false,
        error: null
    };
}

// Build store item of alarm categories based on alarm list
function buildAlarmCategoriesFromAlarmListStoreItem(payload: AlarmList): StoreItem<string> {
    const dic = {};
    let alarmCategories = [];

    // Get all alarm categories
    Object.keys(payload).forEach(k => {
        const categories = [].concat(...payload[k].map(p => p.categories));
        alarmCategories = alarmCategories.concat(categories);
    });

    // Filter unique categories
    alarmCategories = _.uniq(alarmCategories);

    // Assign categories to dictionary
    alarmCategories.forEach(ac => dic[ac] = ac);
    return {
        dictionary: dic,
        isLoading: false,
        isLoaded: true,
        hasError: false,
        error: null
    };
}